export const CONSULTANT_FIRMS = {
  IFPG: 'IFPG',
  FCC: 'FCC',
  FranChoice: 'FranChoice',
  FBA: 'FBA',
  FranServe: 'FranServe',
  Frannet: 'Frannet',
  Bai: 'Bai',
  ThePerfectFranchise: 'The Perfect Franchise',
  Tes: 'Tes',
  BetterDaysFranchiseCo: 'Better Days Franchise Co.',
  Independent: 'Independent',
};
